export const NATIVE_AUTH_CALLBACK = {
  protocol: 'com.leaguehub.app:',
  host: 'auth',
  path: '/callback',
};

export const NATIVE_AUTH_VERIFIER_KEY = 'leaguehub-native-auth-verifier';

export const supportsNativeGoogleAuth = (platform) =>
  platform === 'android' || platform === 'ios';

export const supportsNativeAppleAuth = (platform) => platform === 'ios';

const toBase64Url = (bytes) => {
  let binary = '';
  bytes.forEach((byte) => { binary += String.fromCharCode(byte); });
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

export async function createNativeAuthPkce() {
  const verifier = toBase64Url(crypto.getRandomValues(new Uint8Array(32)));
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  return { verifier, challenge: toBase64Url(new Uint8Array(digest)) };
}

export function parseNativeAuthUrl(rawUrl) {
  try {
    const url = new URL(rawUrl);
    if (
      url.protocol !== NATIVE_AUTH_CALLBACK.protocol ||
      url.hostname !== NATIVE_AUTH_CALLBACK.host ||
      url.pathname !== NATIVE_AUTH_CALLBACK.path
    ) return null;

    const code = url.searchParams.get('code')?.trim();
    const error = url.searchParams.get('error')?.trim();
    if ((!code && !error) || (code && error)) return null;
    return code ? { code } : { error };
  } catch {
    return null;
  }
}

export function resolveNativeAuthTarget(target) {
  return typeof target === 'string' && /^\/(?!\/)[^\\]*$/.test(target)
    ? target
    : '/dashboard';
}
